<template>
    <v-banner class="header-banner">
        <div class="header-banner__map-markers">
            <div class="map-marker map-marker-1"><img src="@/assets/icons/marker-apple.svg" /></div>
            <div class="map-marker map-marker-2"><img src="@/assets/icons/marker-basket.svg" /></div>
            <div class="map-marker map-marker-3"><img src="@/assets/icons/marker-scissors.svg" /></div>
            <div class="map-marker map-marker-4"><img src="@/assets/icons/marker-clothes.svg" /></div>
            <div class="map-marker map-marker-5"><img src="@/assets/icons/marker-house.svg" /></div>
            <div class="map-marker map-marker-6"><img src="@/assets/icons/marker-car.svg" /></div>
        </div>
        <div class="header-banner__content">
            <img :src="$store.state.client_vars.hero.heroBannerLogo">
            <p>{{$store.state.client_vars.hero.heroBannerTagline}}</p>
        </div>
    </v-banner>
</template>

<script>
    // import Alerts from './Alerts.vue';

    export default {
        components: {
        }
    }
</script>

<style lang="scss">
    .header-banner  {
        position: relative;
        background: url('../assets/map.svg');
        background-size: cover;
        background-position: center center;

        .v-banner__wrapper {
            padding: 0 !important;
            overflow: hidden;
            max-height: 500px;

            .v-banner__text {
                line-height: 0;
                width: 100%;
            }

            img {
                width: 100%;
            }
        }

        .header-banner__map-markers {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;

            .map-marker {
                max-width: 90px;
                max-height: 110px;
                position: absolute;
                transition: all 0.4s ease-in-out;
                z-index: -3;

                img {
                    opacity: 0.6;
                }

                @media all and (max-width: 960px) {
                    max-width: 60px;
                    max-height: 70px;
                    
                    img {
                        opacity: 0.4;
                    }
                }

                &-1 {
                    left: 15%;
                    top: 5%;
                }

                &-2 {
                    left: 24%;
                    top: 30%;

                    @media all and (max-width: 960px) {
                        display: none;
                    }
                }

                &-3 {
                    left: 13%;
                    top: 70%;

                    @media all and (max-width: 960px) {
                        left: 4%;
                        top: 22%;
                    }
                }

                &-4 {
                    right: 10%;
                    top: 6%;
                }

                &-5 {
                    right: 22%;
                    top: 20%;

                    @media all and (max-width: 960px) {
                        display: none;
                    }
                }

                &-6 {
                    right: 16%;
                    top: 60%;

                    @media all and (max-width: 960px) {
                        right: 5%;
                        top: 30%;
                    }
                }
            }
        }

        .header-banner__content {
            position: relative;
            padding: 45px 20px 80px 20px;
            text-align: center;


            img {
                max-width: 410px;

                @media all and (max-width: 960px) {
                    width: 60%;
                }
            }

            p {
                font-size: 32px;
                color: #838383;
                margin: 0 auto;
                margin-top: 40px;
                line-height: initial;
                max-width: 820px;
                text-align: center;

                @media all and (max-width: 960px) {
                    font-size: 24px;
                }

                span {
                    color: var(--v-anchor-base);
                    text-decoration: none;
                }
            }
        }
    }

    .header-banner.v-banner--is-mobile {
        .v-banner__wrapper {
            padding-left: 0 !important;

            .v-banner__content {
                padding-right: 0 !important;
            }
        }
    }
</style>